isHandledByWordPress